export const SOUND_LABELS = {
  MAIN: "main",
  ACTION: "action",
};
